import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Library } from 'lucide-react';
import { Button } from './ui/Button';
import { PRODUCT_IMAGE } from './data';
export function Hero() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-36">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-37">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white leading-[1.1] mb-6" data-id="element-38">
          Más fuerza. Más rounds. Menos lesiones.{' '}
          <span className="text-amber-400" data-id="element-39">Todo en un solo sistema.</span>
        </h1>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="relative mx-auto max-w-2xl mb-6 cursor-pointer group" onClick={scrollToCompra} data-id="element-40">
        <div className="absolute inset-0 bg-amber-400/20 blur-3xl rounded-full group-hover:bg-amber-400/30 transition-all duration-500" data-id="element-41" />
        <img src={PRODUCT_IMAGE} alt="Artista Marcial Completo - Sistema de Preparación Física" className="relative z-10 w-[85%] mx-auto h-auto drop-shadow-2xl transition-transform duration-500 group-hover:scale-105" data-id="element-42" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} data-id="element-43">
        <p className="text-lg sm:text-xl text-zinc-300 font-medium max-w-2xl mx-auto mb-6 leading-snug" data-id="element-44">
          Un sistema paso a paso para desarrollar la fuerza, resistencia,
          movilidad y acondicionamiento que el BJJ y el MMA realmente exigen.
        </p>

        <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-45">
          <Badge icon={<FileText className="w-3.5 h-3.5" data-id="element-47" />} text="100% PDF" data-id="element-46" />
          <Badge icon={<Zap className="w-3.5 h-3.5 text-amber-400" data-id="element-49" />} text="Entrega Inmediata" data-id="element-48" />
          <Badge icon={<Library className="w-3.5 h-3.5" data-id="element-51" />} text="10 Modulos + 5 Bonos" data-id="element-50" />
        </div>

        <Button onClick={scrollToCompra} className="text-xl sm:text-2xl py-5 px-10 w-full sm:w-auto" data-id="element-52">
          Quiero llegar al ultimo round
        </Button>
      </motion.div>
    </section>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-1.5 bg-zinc-900/80 border border-zinc-800 px-3 py-1 rounded-full text-zinc-200 text-sm font-medium backdrop-blur-sm whitespace-nowrap" data-id="element-53">
      {icon}
      <span data-id="element-54">{text}</span>
    </div>;
}